export default {"src":"/_next/static/media/eye-off.68262c3b.svg","height":44,"width":44};